import { AverageRunning, BatteryHealth, MotorHealth, ThrottlePercent, PaymentStats, VehiclesUnitStat, BatteriesUnitStat, CarbonStats, DeviceStats, LastOrder, DevicesOverview, Wallet, DealershipDevices } from "../Widgets";
import { DATASET_COLORS } from "../Assets/styles/colors";
import { getDate } from "./datetime";

export const WIDGET_TYPES = {
  // Analytics
  MOTOR_HEALTH:           100,
  AVERAGE_RUNNING:        200,
  BATTERY_HEALTH:         300,
  THROTTLE_PERCENT:       400,

  // 
  PAYMENT_STATS:          500,
  VEHICLES_STATS:         600,
  BATTERIES_STATS:        700,
  CO2_STATS:              800,

  // Dealers
  ALL_DEVICES:            900,
  LAST_ORDER:             1000,
  DEVICES_OVERVIEW:       1100,

  // Seller
  WALLET:                 1200,
};

export const MODULE_TYPES = {
  MOTOR_TEMPERATURE:      101,
  MOTOR_STATUS:           102,
  AVERAGE_RUNNING:        201,
  TOTAL_RUNNING_DST:      202,
  BATTERY_VOLTAGE:        301,
  BATTERY_TEMPERATURE:    302,
  CHARGING_CYCLE:         303,
  BATTERY_HEALTH:         304,
  THROTTLE_PERCENT:       401,
  PAYMENT_STATS:          501,
  VEHICLES_UNIT:          601,
  BATTERIES_UNIT:         701,
  CO2_STATS:              801,
  ALL_DEVICES:            901,
  LAST_ORDER:             1001,
  DEVICES_OVERVIEW:       1101,
  WALLET:                 1201,
};

export const PANELS = {
  ANALYTICS: [
    MODULE_TYPES.MOTOR_TEMPERATURE,
    MODULE_TYPES.MOTOR_STATUS,
    MODULE_TYPES.AVERAGE_RUNNING,
    MODULE_TYPES.TOTAL_RUNNING_DST,
    MODULE_TYPES.BATTERY_VOLTAGE,
    MODULE_TYPES.BATTERY_TEMPERATURE,
    // MODULE_TYPES.CHARGING_CYCLE,
    MODULE_TYPES.BATTERY_HEALTH,
    MODULE_TYPES.THROTTLE_PERCENT,
    MODULE_TYPES.WALLET
  ],
  INVENTORY: [
    MODULE_TYPES.VEHICLES_UNIT,
    MODULE_TYPES.BATTERIES_UNIT,
  ],
  LEASE: [
    MODULE_TYPES.PAYMENT_STATS,
  ],
  DEVICES: [
    MODULE_TYPES.ALL_DEVICES,
    MODULE_TYPES.LAST_ORDER,
    MODULE_TYPES.DEVICES_OVERVIEW,
  ],
  SELLER: [
    MODULE_TYPES.WALLET
  ],
};

export const WIDGET_MODULES = {
  [WIDGET_TYPES.MOTOR_HEALTH]:        [ MODULE_TYPES.MOTOR_TEMPERATURE,    MODULE_TYPES.MOTOR_STATUS ],
  [WIDGET_TYPES.BATTERY_HEALTH]:      [ MODULE_TYPES.BATTERY_TEMPERATURE,  MODULE_TYPES.BATTERY_VOLTAGE, MODULE_TYPES.CHARGING_CYCLE ],
  [WIDGET_TYPES.AVERAGE_RUNNING]:     [ MODULE_TYPES.AVERAGE_RUNNING ],
  [WIDGET_TYPES.THROTTLE_PERCENT]:    [ MODULE_TYPES.THROTTLE_PERCENT ],
  [WIDGET_TYPES.WALLET]:              [ MODULE_TYPES.WALLET ],
  [WIDGET_TYPES.BATTERIES_STATS]:     [ MODULE_TYPES.BATTERIES_UNIT ],
  [WIDGET_TYPES.VEHICLES_STATS]:      [ MODULE_TYPES.VEHICLES_UNIT ],
  [WIDGET_TYPES.PAYMENT_STATS]:       [ MODULE_TYPES.PAYMENT_STATS ],
  [WIDGET_TYPES.CO2_STATS]:           [ MODULE_TYPES.CO2_STATS ],
  [WIDGET_TYPES.ALL_DEVICES]:         [ MODULE_TYPES.ALL_DEVICES ],
  [WIDGET_TYPES.LAST_ORDER]:          [ MODULE_TYPES.LAST_ORDER ],
  [WIDGET_TYPES.DEVICES_OVERVIEW]:    [ MODULE_TYPES.DEVICES_OVERVIEW ],
};

export const WIDGET_COMPONENTS = {
  [WIDGET_TYPES.MOTOR_HEALTH]:        { title: "Motor Health",          component: MotorHealth },
  [WIDGET_TYPES.BATTERY_HEALTH]:      { title: "Battery Health",        component: BatteryHealth },
  [WIDGET_TYPES.AVERAGE_RUNNING]:     { title: "Average Running",       component: AverageRunning },
  [WIDGET_TYPES.THROTTLE_PERCENT]:    { title: "Throttle Percentage",   component: ThrottlePercent },
  [WIDGET_TYPES.BATTERIES_STATS]:     { title: "Battery Unit Stats",    component: BatteriesUnitStat  },
  [WIDGET_TYPES.VEHICLES_STATS]:      { title: "Vehicle Unit Stats",    component: VehiclesUnitStat },
  [WIDGET_TYPES.PAYMENT_STATS]:       { title: "Payment Stats",         component: PaymentStats },
  [WIDGET_TYPES.CO2_STATS]:           { title: "Carbon Emission Stats",         component: CarbonStats },

  // [WIDGET_TYPES.ALL_DEVICES]:         { title: "Dealerships",         component: DeviceStats },
  [WIDGET_TYPES.ALL_DEVICES]:         { title: "Dealerships",         component: DealershipDevices },
  [WIDGET_TYPES.LAST_ORDER]:          { title: "Dealerships",         component: LastOrder },
  [WIDGET_TYPES.DEVICES_OVERVIEW]:    { title: "Dealerships",         component: DevicesOverview },
  [WIDGET_TYPES.WALLET]:              { title: "Wallet",              component: Wallet },
};

const ALARM_TYPES = {
  1: { idx: 1, label: "High L2", color: DATASET_COLORS.DANGER_HIGH, graph: true, },
  2: { idx: 2, label: "High L1", color: DATASET_COLORS.WARNING_HIGH, graph: true, },
  3: { idx: 3, label: "Normal",  color: DATASET_COLORS.SUCCESS, graph: false, },
  4: { idx: 4, label: "Low L2",  color: DATASET_COLORS.DANGER_LOW, graph: true, },
  5: { idx: 5, label: "Low L1",  color: DATASET_COLORS.WARNING_LOW, graph: true, },
};

export const STATS_ENUMS = {
  [MODULE_TYPES.MOTOR_TEMPERATURE]: {
    1: { idx: 1, label: "Low",    graph: true,  color: DATASET_COLORS.WARNING_HIGH },
    2: { idx: 2, label: "Normal", graph: false, color: DATASET_COLORS.SUCCESS },
    3: { idx: 3, label: "High",   graph: true,  color: DATASET_COLORS.DANGER_HIGH },
  },

  [MODULE_TYPES.MOTOR_STATUS]: {
    1: { idx: 1, label: "Properly Working", graph: false, color: DATASET_COLORS.SUCCESS },
    2: { idx: 2, label: "Faulty Motors",    graph: true, color: DATASET_COLORS.WARNING_HIGH },
  },

  [MODULE_TYPES.AVERAGE_RUNNING]: {
    pools: {
      1: { idx: 1, label: "0-15"  },
      2: { idx: 2, label: "15-30" },
      3: { idx: 3, label: "30-45" },
      4: { idx: 4, label: "45-60" },
      5: { idx: 5, label: "60+"   },
    },
  },

  [MODULE_TYPES.BATTERY_VOLTAGE]:         ALARM_TYPES,
  [MODULE_TYPES.BATTERY_TEMPERATURE]:     ALARM_TYPES,

  [MODULE_TYPES.CHARGING_CYCLE]: {
    1: { idx: 1, label: "0-25%",      color: DATASET_COLORS.BRANDY },
    2: { idx: 2, label: "25-50%",     color: DATASET_COLORS.BRANDY },
    3: { idx: 3, label: "50-75%",     color: DATASET_COLORS.BRANDY },
    4: { idx: 4, label: "75-100%",    color: DATASET_COLORS.BRANDY },
  },

  [MODULE_TYPES.BATTERY_HEALTH]: {
    1: { idx: 1, label: "0-25%",      color: DATASET_COLORS.BRANDY },
    2: { idx: 2, label: "25-50%",     color: DATASET_COLORS.BRANDY },
    3: { idx: 3, label: "50-75%",     color: DATASET_COLORS.BRANDY },
    4: { idx: 4, label: "75-100%",    color: DATASET_COLORS.BRANDY },
  },

  [MODULE_TYPES.THROTTLE_PERCENT]: {
    1: { idx: 1, label: "0-25%",      color: DATASET_COLORS.PURPLE },
    2: { idx: 2, label: "25-50%",     color: DATASET_COLORS.PURPLE },
    3: { idx: 3, label: "50-75%",     color: DATASET_COLORS.PURPLE },
    4: { idx: 4, label: "75-100%",    color: DATASET_COLORS.PURPLE },
  },

  [MODULE_TYPES.ALL_DEVICES]: {
    1: { idx: 1, label: "0%",      color: DATASET_COLORS.SUCCESS },
    2: { idx: 2, label: "25%",     color: DATASET_COLORS.WARNING_HIGH },
    3: { idx: 3, label: "50%",     color: DATASET_COLORS.PURPLE },
    4: { idx: 4, label: "75%",    color: DATASET_COLORS.WARNING_LOW },
    5: { idx: 5, label: "100%",    color: DATASET_COLORS.DANGER_HIGH },
  },
};

export const MODULE_CATEGORIES = {
  [MODULE_TYPES.MOTOR_TEMPERATURE]: [
    [STATS_ENUMS[MODULE_TYPES.MOTOR_TEMPERATURE].LOW],
    [STATS_ENUMS[MODULE_TYPES.MOTOR_TEMPERATURE].NORMAL],
    [STATS_ENUMS[MODULE_TYPES.MOTOR_TEMPERATURE].HIGH],
  ]
};

export const MOTOR_FAULTS = [
  { idx: 1, nm: "Drive", },
  { idx: 2, nm: "Hall Sensor", },
  { idx: 3, nm: "High Current", },
  { idx: 4, nm: "High Load", },
  { idx: 5, nm: "High Motor Temperature", },
  { idx: 6, nm: "High Speed", },
  { idx: 7, nm: "High Temperature", },
  { idx: 8, nm: "High Voltage", },
  { idx: 9, nm: "Low Voltage", },
  { idx: 10, nm: "Mosfet", },
  { idx: 11, nm: "Motor Blocking", },
  { idx: 12, nm: "Motor Lost Hall", },
  { idx: 13, nm: "Motor Phase Loss", },
  { idx: 14, nm: "Motor Stuck", },
  { idx: 15, nm: "Throttle", },
];

export const processWidgetData = (response) => {
  let data = {};

  response.forEach((d) => {
    if (d.data.every((stat) => stat._id === null)) {
      let stat = d.data[0];
      if (stat) {
        let newData = [];

        Object.keys(stat).forEach((s) => {
          if (s === "_id") return;
          newData.push({ idx: s, count: stat[s] });
        });

        d.data = newData;
      }
    } else {
    }
  });

  response.forEach((d) => data[d.id] = d.data);
  return data;
};

export const processReportData = (response, accessor = "vehCnt") => {
  const modelMap = {};

  response.forEach((row) => {
    const { md, typ } = row._id;      //md = modelId, typ = category

    if (typ) {
      if (!modelMap[md]) modelMap[md] = { model: md, count: [] };
      modelMap[md].count.push({ idx: typ, count: row[accessor] });
    } else {
      let data = { ...row };
      delete data._id;

      const count = Object.keys(data).map((typ) => ({ idx: Number(typ), count: data[typ] }));
      modelMap[md] = { model: md, count: count };
    }
  });

  Object.keys(modelMap).forEach((model) => {
    modelMap[model].count.sort((a, b) => a.idx - b.idx);
  });

  return Object.values(modelMap);
};

export const getDummyDatasetMap = (days = 30) => {
  // Returns Dummy Dataset for Last 30 Days

  let dataset = new Map();

  let todayTs = new Date().setHours(0, 0, 0, 0);
  let today = new Date(todayTs);

  while (days !== 0) {
    dataset.set(new Date(todayTs).setDate(today.getDate() - days), null);
    days--;
  }

  return dataset;
}

export const generateDatasetForDays = (days = 30, data, accessor, divisor, color) => {
  let validPoints = [];
  let dataPoints = [];

  let datasetMap = getDummyDatasetMap(days);

  let dataMap = {};
  data.forEach((day) => {
    dataMap[new Date(day.sdt * 1000).setHours(0, 0, 0, 0)] = day;
  });

  datasetMap.forEach((_, day) => {
    let dataItem = {
      id: day,
      label: getDate(day, true, " ", true),
      color: color,
      count: 0,
    };

    // If Entry Exists for this Day in Distance Data
    if (!dataMap[day]) {
      datasetMap.set(day, dataItem);
      return;
    }

    let d = dataMap[day];
    validPoints.push(d);
    dataPoints.push(d[accessor]);

    let dataSdt = new Date(d.sdt * 1000).setHours(0, 0, 0, 0);

    if (datasetMap.has(dataSdt)) {
      dataItem.count = (d[accessor] / divisor);
    }

    datasetMap.set(dataSdt, dataItem);
  });

  let dataset = [];
  datasetMap.forEach((set) => dataset.push(set));

  const sum = dataPoints.reduce((a, b) => a + b, 0);
  const average = (sum / dataPoints.length) || 0;

  return [ dataset, sum, average, validPoints ];
}
